import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import FormsSearch from './search';
import FormsList from './list';
import FormTemplateOrFormResponse from './create';
import FormsSkrSearch from './searchSkr';
import SkrFormTemplateOrResponse from './createSkr';
import EnteredAnswersList from './enteredFtr';
import MaintainFTR from './maintain';

export const formsRoutes = [
  {'component': <FormsSearch />, 'path': paths.FormsSearch},
  {'component': <FormsList />, 'path': paths.FormsList},
  {
    'component': <FormTemplateOrFormResponse />,
    'path': paths.NewForm,
  },
  {
    'component': <FormTemplateOrFormResponse />,
    'path': paths.NewFormResponse,
  },
  {
    'component': <FormTemplateOrFormResponse />,
    'path': paths.FormTemplateOrFormResponse,
  },
  {'component': <FormsSkrSearch />, 'path': paths.FormsSkrSearch},
  {
    'component': <SkrFormTemplateOrResponse />,
    'path': paths.SkrFormTemplateOrResponse,
  },
  {
    'component': <SkrFormTemplateOrResponse />,
    'path': paths.SkrFormTemplateCreate,
  },
  {
    'component': <EnteredAnswersList />,
    'path': paths.EnteredAnswersList,
  },
  {'component': <MaintainFTR />, 'path': paths.MaintainFormsServices},
];
